import React, { useEffect } from "react";
import Container from "../components/Container";
import TariffPage from "../components/tariff/TariffPage";
import image from "../assets/ResortGallery/RG3.jpg"
import TopBannerSection from "../components/TopBannerSection";

const Tariff = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);
  return (
    <>
      <Container>
        <TopBannerSection
          Image={image}
          pageName={"TARIFF"}
          Quote={"Exclusive Tariff & Pricing"}
        />
        <TariffPage />
      </Container>
    </>
  );
};

export default Tariff;
